import { render, staticRenderFns } from "./curyBraes.vue?vue&type=template&id=2006b79a&scoped=true&"
import script from "./curyBraes.vue?vue&type=script&lang=js&"
export * from "./curyBraes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006b79a",
  null
  
)

export default component.exports